<template lang="pug">
.custom_dialog
  .dialog_container
    .download_btn(@click="download")
      font-awesome-icon.mr-1(:icon="['fas', 'download']")
      | 下載繳費單
    .dialog_close_btn(@click="closeClick")
      img(src="@/assets/img/icons/close.svg")
    img.bill(v-if="tempCanvas", :src="tempCanvas.toDataURL('image/jpeg', 1.0)")
    #pdfContent.dialog_content(v-if="imageCreateStatus")
      div(style="width: 910px; height: 20px")
      .header.d-flex.align-items-center.justify-content-center
        img(
          src="@/assets/img/logo/logo_xs.png",
          style="width: 200px; height: auto;"
        )
        p(
          style="width: 710px; font-size: 28px; font-weight: bold; text-align: center;",
        ) TOP巔峰籃球訓練營
          br
          | {{ orderDetail.program_product_group_name }} 繳費通知單
      div(style="width: 910px; height: 20px")
      table(style="width: 910px; height: auto; margin: auto", border="1")
        tbody
          tr(style="height: auto;" v-for="student in orderDetail.program_apply_targets")
            td(
              style="width: 260px; height: auto; font-size: 18px; font-weight: bold; text-align: center; background-color:#F3F3F3;",
              colspan="2"
            ) 學生姓名
            td(
              style="width: 650px; height: auto; font-size: 18px; text-align: center;",
              colspan="5"
            ) {{ student.name }}
          tr(style="height: auto;" v-for="course in orderDetail.program_order_items" v-if="!course.is_additional")
            td(
              style="width: 260px; height: auto; font-size: 18px; font-weight: bold; text-align: center; background-color:#F3F3F3;",
              colspan="2"
            ) 參加班別
            td(
              style="width: 650px; height: auto; font-size: 18px; text-align: center;",
              colspan="5"
            ) {{ course.program_product_name }}
          tr(style="height: auto;")
            td(
              style="width: 910px; height: auto; font-size: 18px; text-align: center; font-weight: bold; background-color:#F3F3F3;",
              colspan="7"
            ) 費用細項
          template(v-if="!item.is_additional" v-for="item in orderDetail.program_order_items")
            tr(style="height: auto;")
              td(
                style="width: 650px; height: auto; font-size: 18px;text-align: center;",
                colspan="5"
              ) {{ item.program_product_name }} X{{item.quantity}}
              td(
                style="width: 260px; height: auto; font-size: 18px; text-align: right;"
              ) NT${{ item.total_price }}
          template(v-if="item.is_additional" v-for="item in orderDetail.program_order_items")
            tr(style="height: auto;")
              td(
                style="width: 650px; height: auto; font-size: 18px;text-align: center;",
                colspan="5"
              ) {{ item.program_product_name }} X{{item.quantity}}
              td(
                style="width: 260px; height: auto; font-size: 18px; text-align: right;"
              ) NT${{ item.total_price }}
          template(v-for="discount in orderDetail.program_order_discounts")
            tr(style="height: auto;")
              td(
                style="width: 650px; height: auto; font-size: 18px;text-align: center;",
                colspan="5"
              ) {{ discount.plan_name }} X{{discount.quantity}}
              td(
                style="width: 260px; height: auto; font-size: 18px; text-align: right;"
              ) -NT${{ discount.total_discount }}
          tr(style="height: auto;")
            td(
              style="width: 650px; height: auto; font-size: 18px; font-weight: bold; background-color:#F3F3F3; text-align: center;",
              colspan="5"
            ) 應繳學費總額
            td(
              style="width: 260px; height: auto; font-size: 18px; font-weight: bold; color: red; background-color:#F3F3F3; text-align: right;",
              colspan="2"
            ) NT${{ orderDetail.price }}
          tr(style="height: auto;")
            td(style="width: 130px; height: auto; font-size: 18px;") 匯款資訊
            td(
              style="width: 780px; height: auto; color: red; font-size: 18px; text-align: center;",
              colspan="6"
            ) {{ payInfo1 }}<br>{{ payInfo2 }}<br>{{ payInfo3 }}
          tr(style="height: auto;")
            td(style="width: 130px; height: auto;")
              span(style="color: red; font-size: 18px;") 課程規範
              span(style="font-size: 18px;") （繳費後視同同意課程規範）
            td(
              style="width: 780px; height: auto; font-size: 18px;",
              colspan="6",
              v-html="orderDetail.program_product_group?orderDetail.program_product_group.rule:''"
            ) 
          tr(style="height: auto;")
            td(
              style="width: 910px; height: auto; font-size: 18px;",
              colspan="7"
            ) 備註事項：
              span(style="color: red;") 繳費視同同意以上規範
          tr(style="height: auto;")
            td(
              style="width: 360px; height: auto; font-size: 18px;",
              colspan="3"
            ) 繳費期限
            td(
              style="520; height: auto;color: red; font-size: 18px;",
              colspan="4"
            ) {{ formatDate(orderDetail.expired_at) }}
          tr(style="height: auto;")
            td(style="width: 910px; height: auto;", colspan="7")
              p(style="text-align: right; font-size: 18px;") 如有繳費問題，請洽：（02）2935-6123 與客服專員聯絡
              p(style="text-align: right; font-size: 18px;") 0971-692-973 與客服專員聯絡
  dialog-loading(v-if="loadingDialogShow", :content="loadingContent") 
</template>

<script>
import html2Canvas from "html2canvas";
import { getOrderByID } from "@/api/ecommerce";
import moment from "moment";
import DialogLoading from "@/components/dialog/DialogLoading";

export default {
  name: "BillDialog",
  components: {
    "dialog-loading": DialogLoading,
  },
  props: {
    orderId: Number,
  },
  data() {
    return {
      orderDetail: {},
      courseList: [
        {
          product_group: {
            name: "",
          },
          product: {
            name: "",
            product_specs: [
              {
                name: "",
                val: "",
              },
            ],
          },
        },
      ],
      extraList: [],
      imageCreateStatus: true,
      tempCanvas: null,
      loadingDialogShow: true,
      loadingContent: "載入中....",
      payInfo1: "台灣銀行 (004) 048-0010-08932",
      payInfo2: "戶名：巔峰實業有限公司(連城分行)",
      payInfo3: "匯款完成後請與班務聯繫轉帳後五碼",
    };
  },
  created() {
    this.getOrderByID();
  },
  methods: {
    closeClick() {
      this.$emit("closeBillDialog");
    },
    getOrderByID() {
      getOrderByID(this.orderId).then((response) => {
        this.courseList = [];
        this.extraList = [];
        this.orderDetail = response.data;
        for (let index in this.orderDetail.order_items) {
          let temp = this.orderDetail.order_items[index];
          if ("PROGRAM_CAMP_EXTRA" == temp.product_group.category) {
            this.extraList.push(temp);
          } else {
            this.courseList.push(temp);
          }
        }
        setTimeout(() => {
          this.createImage();
        }, 3000);
      });
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("YYYY/MM/DD");
      }
      return "";
    },
    createImage() {
      let vm = this;
      var targetDom = document.querySelector("#pdfContent");
      var copyDom = targetDom.cloneNode(true);
      copyDom.style.width = targetDom.scrollWidth + "px";
      copyDom.style.height = targetDom.scrollHeight + 35 + "px";
      document.body.appendChild(copyDom);
      html2Canvas(copyDom, {
        scale: 2,
        useCORS: true,
      }).then(function (canvas) {
        document.body.removeChild(copyDom);
        vm.tempCanvas = canvas;
        vm.imageCreateStatus = false;
        vm.loadingDialogShow = false;
      });
    },
    download() {
      let link = document.createElement("a");
      link.href = this.tempCanvas.toDataURL("image/jpeg", 1.0);
      link.setAttribute("download", "TOP巔峰籃球訓練營繳費單.png");
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/dialog/dialog";

img.bill {
  width: 100%;
  height: auto;
  margin-top: 40px;
}

.download_btn {
  color: $color_red;
  font-weight: 500;
  width: fit-content;
  position: fixed;

  &:hover {
    color: rgba(216, 68, 53, 0.7);
    cursor: pointer;
  }

  &:hover svg {
    opacity: 0.8;
  }
  svg {
    color: $c-text;
  }
}

.custom_dialog {
  .dialog_container {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transform: none;
    border-radius: 0;
    overflow: auto;
  }

  .dialog_content {
    margin-top: 50px;
    overflow: scroll;
    height: auto;
    max-height: calc(100vh - 100px);
  }

  .dialog_close_btn {
    position: fixed;
    height: auto;
    cursor: pointer;
    right: 40px;
    top: 40px;
  }
}
td {
  padding: 20px;
}

@media (max-width: 575px) {
  .custom_dialog {
    .dialog_close_btn {
      height: auto;
      cursor: pointer;
      right: 20px;
    }
  }
}

@media print {
  .dialog_close_btn {
    display: none;
  }
}
</style>
